"use client";

import {
  ClerkAvatar,
  type ClerkAvatarProps,
} from "modules/common/components/avatar/ClerkAvatar";
import type { ActivityStatus } from "modules/common/model/models";
import { useUserActivityStatus } from "modules/users/hooks/useUserActivityStatus";

interface UserActivityAvatarProps extends Omit<ClerkAvatarProps, "online"> {
  userId?: string;
  initialStatus?: ActivityStatus;
  resolveActivityStatus?: boolean;
}

/** User avatar with the privacy-aware active-now indicator. */
export function UserActivityAvatar({
  userId,
  initialStatus,
  resolveActivityStatus = true,
  ...avatarProps
}: UserActivityAvatarProps) {
  const status = useUserActivityStatus(userId, initialStatus, {
    enabled: resolveActivityStatus,
  });

  return <ClerkAvatar {...avatarProps} online={status === "active"} />;
}
